import React from 'react'
import { default as ReactPhoneInput, PhoneInputProps } from 'react-phone-input-2'
import { Program } from '@citruscamps/citrus-client'
import { SupportedCountries } from '../../constants/application'
import { Address } from '../../utils/address'
import 'react-phone-input-2/lib/bootstrap.css'

interface IProps extends PhoneInputProps {
  id?: string
  name?: string
  className?: string
  readOnly?: true
  program?: Program
}

export const PhoneInput = ({ program, id, name, className, readOnly, ...props }: IProps) => {
  const language: string | undefined = navigator.language.split('-').pop()?.toLowerCase()
  const languageCountry =
    language && SupportedCountries.includes(language) ? language : SupportedCountries[0]
  const country =
    (program?.address &&
      Address.fromGeocode(program?.address)?.country_short_code?.toLowerCase()) ||
    languageCountry
  return (
    <ReactPhoneInput
      {...props}
      country={country}
      onlyCountries={SupportedCountries}
      inputProps={{
        id,
        name,
        className,
        readOnly,
      }}
    />
  )
}
